var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChangeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 8.14286L10.3333 11M10.3333 11L7.66667 8.14286M10.3333 11V3.85714C10.3333 3.09938 10.0524 2.37266 9.55228 1.83684C9.05219 1.30102 8.37391 1 7.66667 1H3.66667C2.95942 1 2.28115 1.30102 1.78105 1.83684C1.28095 2.37266 1 3.09938 1 3.85714V11",
    stroke: "#0E1337",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeIcon);
export default __webpack_public_path__ + "static/media/changeIcon.9d9d8c0ca220ca6514a129f7e25d9736.svg";
export { ForwardRef as ReactComponent };